import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import {Config} from '../utils/Config';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import {LOCALSTORAGE_KEY} from '../utils/constants.js';
import {setSearchQuery} from '../actions/main.js';
import {setHomeActiveMenu} from '../actions/main.js';
import {connect} from 'react-redux';
import '../App.scss';

class Ticket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketData: '',
      isLoading: true,
      isSnackBarOpen: false,
      isMailsuccess: false,
    };
  }

  componentDidMount() {
    let {bookingId, email, provider} = this.props.match.params;

    let busProvider = '';
    if (provider === 'APSRTC') {
      busProvider = '&provider=APSRTC';
      bookingId = bookingId.split(',');
      bookingId = bookingId.join();
    }

    const url = `${Config.SECURED_API_HOST}/api/platform/bus/ticket?bookingid=${bookingId}&email=${email}${busProvider}`;
    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        if (res.Error === null) {
          this.setState({
            ticketData: res,
            isLoading: false,
          });
        } else {
          this.openSnackBar(res.Error);
          this.setState({
            isLoading: false,
          });
        }
        console.log(res);
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        console.log(error);
        this.openSnackBar('Something went wrong! Please Try Again');
      });
  }

  bookreturnTicket = () => {
    const s = JSON.parse(
      window.localStorage.getItem(LOCALSTORAGE_KEY.SOURCE_CITY)
    );
    const d = JSON.parse(
      window.localStorage.getItem(LOCALSTORAGE_KEY.DESTINATION_CITY)
    );

    let query = {type: 'source', data: d.data};
    window.localStorage.setItem(
      LOCALSTORAGE_KEY.SOURCE_CITY,
      JSON.stringify(query)
    );

    query = {type: 'destination', data: s.data};
    window.localStorage.setItem(
      LOCALSTORAGE_KEY.DESTINATION_CITY,
      JSON.stringify(query)
    );
    this.props.setHomeActiveMenu('home');
    this.props.history.push('/rbooking-bus');
  };

  bookticket = () => {
    this.props.setHomeActiveMenu('home');
    this.props.history.push('/rbooking-bus');
  };

  cancelTicekt = () => {
    let {ticketData} = this.state;

    if (ticketData.status === 'CANCELLED') {
      return this.openSnackBar('Ticket has been Already Cancelled');
    }

    let doj = ticketData.doj;
    if (doj) {
      if (/^[0-9]*$/.test(doj)) {
        doj = parseInt(doj);
      } else {
        doj = doj.replace(/(\d+)(?:(st|nd|rd|th))/gm, `$1`);
      }
    }

    doj = new Date(doj).getTime();
    var today = new Date().getTime();
    // console.log(doj, today);

    if (doj > today) {
      const {bookingId, email, provider} = this.props.match.params;
      this.props.history.push(
        `/rbooking-bus/cancel-ticket/${bookingId}/${email}/${provider}`
      );
    } else {
      this.openSnackBar(
        'Error in Ticket Deatails! Please check Date of Journey'
      );
    }
  };

  MialnSMSTicket = () => {
    const {bookingId, email} = this.props.match.params;
    const mailURL = `${Config.SECURED_API_HOST}/api/platform/bus/sendsmsemail?bookingid=${bookingId}&email=${email}`;
    fetch(mailURL)
      .then((res) => res.json())
      .then((res) => {
        this.setState({isMailsuccess: true});
        this.openSnackBar(
          'Mail & SMS Successfully Sent! Please Check your mail'
        );
      })
      .catch((error) => {
        console.log(error);
        this.openSnackBar('Something went wrong! Please Try Again');
      });
  };

  time_convert = (num) => {
    const hours = Math.floor(num / 60);
    const minutes = num % 60;
    return `${hours}:${minutes}`;
  };

  openSnackBar = (message) => {
    const msg = (
      <div className="snackbar-msg" id="message-id">
        {message}
      </div>
    );
    this.setState({isSnackBarOpen: true, message: msg});
  };

  handleClose = () => {
    this.setState({isSnackBarOpen: false});
  };

  render() {
    const data = this.state.ticketData;
    let passenger = data.inventoryItems;
    let pickupTime = data.pickupTime;

    let seatName =
      data && data.inventoryItems.length > 0
        ? Object.keys(data.inventoryItems).map((key, i) => {
            return <div key={i}>{passenger[key].seatName}</div>;
          })
        : '';

    let passengerName =
      data && data.inventoryItems.length > 0
        ? Object.keys(data.inventoryItems).map((key, i) => {
            return <div key={i}>{passenger[key].passenger.name}</div>;
          })
        : '';

    var date = new Date(parseInt(data.doj));
    if (this.props.match.params.provider === 'APSRTC') {
      date = data.doj;
    } else {
      date = date.toDateString();
      pickupTime = this.time_convert(data.pickupTime);
    }

    const header = (
      <div className="header">
        <Grid container justifyContent="flex-start" className="from-to">
          <Grid
            item
            xs={1}
            className="backBtn"
            onClick={() => {
              this.props.history.goBack();
            }}
          >
            <i className="material-icons">arrow_back</i>
          </Grid>
          <Grid item xs={10}>
            <div className="title">
              <span>Ticket Details</span>
            </div>
          </Grid>
        </Grid>
      </div>
    );

    const ticketDetails = (
      <div>
        <div className="ticket-Details">
          <div className="route">
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} className="title">
                <span>
                  {data.status},{' ' + date}
                </span>
              </Grid>
            </Grid>
            <hr />
            <Grid container justifyContent="flex-start">
              <Grid item xs={6}>
                <span className="label-text">FROM</span>
                <br />
                <span>{data.sourceCity}</span>
              </Grid>
              <Grid item xs={1}>
                <i className="material-icons">arrow_right_alt</i>
              </Grid>
              <Grid item xs={5} style={{textAlign: 'right'}}>
                <span className="label-text">TO</span>
                <br />
                <span>{data.destinationCity}</span>
              </Grid>
            </Grid>
            <hr />

            <Grid container justifyContent="flex-start">
              <Grid item xs={6}>
                <span className="label-text">BOARDS</span>
                <br />
                <span>{pickupTime}</span>
              </Grid>
              <Grid item xs={6} style={{textAlign: 'right'}}>
                <span className="label-text">BOARDING POINT</span>
                <br />
                <span> {data.pickupLocation}</span>
              </Grid>
            </Grid>
          </div>

          <hr />

          <div>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12}>
                <span className="label-text">TRAVEL</span>
                <br />
                <span>
                  {data.travels} {data.busType}{' '}
                </span>
              </Grid>
            </Grid>
          </div>

          <hr />

          <div>
            <Grid container justifyContent="flex-start">
              <Grid item xs={6}>
                <span className="label-text">SEAT</span>
                <br />
                {seatName}
              </Grid>
              <Grid item xs={6} style={{textAlign: 'right'}}>
                <span className="label-text">
                  PASSENGERS <br />
                </span>
                {passengerName}
              </Grid>
            </Grid>
          </div>
          <hr />
          <div>
            <span className="label-text">BOARDING POINT DETAILS</span>
            <br />
            {data.pickupLocation},{data.sourceCity} ,{data.pickUpContactNo}
          </div>
        </div>
        <div className="ticket-Details">
          <div>
            <Grid container justifyContent="flex-start">
              <Grid item xs={6}>
                <span className="label-text">TICKET NUMBER</span>
                <br />
                {data.tin}
              </Grid>
              <Grid item xs={6} style={{textAlign: 'right'}}>
                <span className="label-text">
                  TOTAL <br />
                </span>
                {'Rs ' + data.totalFare}
              </Grid>
            </Grid>
          </div>
          <hr />
          <div>
            <span className="label-text">PNR NUMBER</span> <br />
            {data.pnr}
          </div>
        </div>
      </div>
    );

    const bottommenu = (
      <div
        className="ctkt-btn-success-bottom-fixed"
        onClick={() => this.props.history.push('/rbooking-bus')}
      >
        Home
      </div>
    );

    const returnTicketButton = (
      <button
        type="button"
        className="btn btn-success"
        style={{fontSize: '14px', marginLeft: '10px'}}
        onClick={this.bookreturnTicket}
      >
        Book Return Ticket
      </button>
    );

    const bookticket = (
      <button
        type="button"
        className="btn btn-success"
        style={{fontSize: '14px'}}
        onClick={this.bookticket}
      >
        Book Another Ticket
      </button>
    );

    const cancelTicketButton = (
      <button
        type="button"
        className="btn btn-success"
        style={{fontSize: '14px', marginLeft: '10px'}}
        onClick={this.cancelTicekt}
      >
        Cancel Ticket
      </button>
    );

    const MialnSMSTicket = (
      <button
        type="button"
        className="btn btn-success"
        style={{fontSize: '14px'}}
        onClick={this.MialnSMSTicket}
      >
        Mail and SMS Ticket
      </button>
    );

    const TicketBlock = this.state.isLoading ? (
      <div className="loading fixed">
        <CircularProgress />
      </div>
    ) : data && data.inventoryItems.length > 0 ? (
      ticketDetails
    ) : (
      ''
    );

    return (
      <div className="ticket" style={{background: 'lightgrey'}}>
        {header}
        <div className="container buttons">
          {bookticket}
          {returnTicketButton}
        </div>
        {bottommenu}
        {TicketBlock}
        <div className="container buttons" style={{paddingBottom: '80px'}}>
          {MialnSMSTicket}
          {cancelTicketButton}
        </div>

        <Snackbar
          anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
          open={this.state.isSnackBarOpen}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          autoHideDuration={5000}
          message={this.state.message}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    searchQuery: state.searchReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSearchQuery: (query) => {
      dispatch(setSearchQuery(query));
    },
    setHomeActiveMenu: (menu) => {
      dispatch(setHomeActiveMenu(menu));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Ticket);
